import { render, staticRenderFns } from "./IntegrationNumber.vue?vue&type=template&id=f2fd4a36&scoped=true&"
import script from "./IntegrationNumber.vue?vue&type=script&lang=ts&"
export * from "./IntegrationNumber.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationNumber.vue?vue&type=style&index=0&id=f2fd4a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fd4a36",
  null
  
)

export default component.exports